import { Editor } from "@tinymce/tinymce-react";
import { useState } from "react";
import apiClient from "./../api.js";

export default function BlogUpload() {
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [metatitle, setMetaTitle] = useState("");
  const [category, setCategory] = useState("");
  const [metadescription, setMetaDescription] = useState("");
  const [content, setContent] = useState("");
  const [blogimage, setBlogImage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    await apiClient.post("blog/create", {
      title,
      slug,
      metatitle,
      category,
      metadescription,
      content,
      blogimage,
    });

    alert("Blog Uploaded!");
  };

  return (
    <div className="container my-3">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit} className="listingForm">
            <input
              type="text"
              className="listing-input"
              placeholder="Blog Title"
              onChange={(e) => setTitle(e.target.value)}
            />

            <input
              type="text"
              className="listing-input"
              placeholder="Slug"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
            />
            <input
              type="text"
              className="listing-input"
              placeholder="Meta Title"
              value={metatitle}
              onChange={(e) => setMetaTitle(e.target.value)}
            />
            <input
              type="text"
              className="listing-input"
              placeholder="Meta Description"
              value={metadescription}
              onChange={(e) => setMetaDescription(e.target.value)}
            />
            <input
              type="text"
              className="listing-input"
              placeholder="Blog image URL"
              value={blogimage}
              onChange={(e) => setBlogImage(e.target.value)}
            />

            <select
              className="listing-input"
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              <option value="general">General</option>
              <option value="lifestyle">Lifestyle</option>
              <option value="policies finance">Policies & Finance</option>
              <option value="city news">City News</option>
              <option value="celebrity house">Celebrity House</option>
              <option value="taxation">Taxation</option>
              <option value="entertainment">Entertainment</option>
              <option value="global news">Global News</option>
            </select>

            <Editor
              apiKey="tt08amtyiz5bzwzu9xzh9n8qvlbjg6obld2q7xjftgdszlrk"
              init={{
                height: 500,
                menubar: true,
                plugins: "link lists image table code",
                toolbar:
                  "undo redo | formatselect | bold italic | alignleft aligncenter alignright | " +
                  "h1 h2 h3 | bullist numlist | link image | table tabledelete | " +
                  "tableprops tablerowprops tablecellprops | " +
                  "tableinsertrowbefore tableinsertrowafter | " +
                  "tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | code",
              }}
              onEditorChange={(newValue) => setContent(newValue)}
            />
            <button className="upload-btn btn" type="submit">
              Upload Blog
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
